// extracted by mini-css-extract-plugin
module.exports = {"desc":"description_desc__EALTZ","light":"description_light__ddfPL","forced":"description_forced__kH87D"};